import { QueryKey } from "@tanstack/react-query";

export const appointableAsCustomerQueryKeys = {
  all: () => ["appointableAsCustomerQueryKeys"] as QueryKey,
  list: (filters: Readonly<{ [k: string]: any }>) =>
    [...appointableAsCustomerQueryKeys.all(), { filters }] as QueryKey,
  categories: (filter?: Readonly<Record<string, any>>) =>
    ["activity-categories", filter] as QueryKey,
};
